module.exports = __webpack_public_path__ + "statics/img/earthwork-3.6759ae9f.png";